module.exports = __webpack_public_path__ + "img/plus-circle-solid.7496c38f.svg";